import { readMatchFilters, type MatchFilters } from './productMatchFilters';

export function useProductMatchSearch(args: {
  partyId?: string;
  productId?: string;
  searchStr: string;
  partyParam: string;
}): MatchFilters {
  const fallback = new URLSearchParams(args.searchStr);
  return readMatchFilters(
    args.partyId,
    args.productId,
    fallback.get(args.partyParam),
    fallback.get('productId'),
  );
}
